module.exports = __webpack_public_path__ + "img/nn-shield.9658f45b.png";